import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export default function Resume() {
  return (
    <section className="portfolio--section" id="Resume">
      <div className="portfolio--container-box">
        <div className="portfolio--container">
          <p className="sub--title">Resume</p>
          <h2 className="section--heading">Here is my current resume (Updated 2025)</h2>
          {/* <Document file="/resume-updated_at_2025.pdf" >
            <Page pageNumber={1} />
          </Document> */}
        </div>

        <div>
          <button 
            className="btn btn-github" 
            onClick={() => window.open("/resume-updated_at_2025.pdf", '_blank')}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7,10 12,15 17,10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Download Resume
          </button>
        </div>
      </div>
    </section>
  );
}
